import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'

import type { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'
import type ReportsForm from 'modules/employees/lib/forms/Reports'

import ActivityTimeoffFields from './ActivityTimeoffFields'
import CompanyTimeoffFields from './CompanyTimeoffFields'
import ScheduleTimeoffFields from './ScheduleTimeoffFields'
import UsedTimeoffFields from './UsedTimeoffFields'

interface Props {
  form: ReportsForm
  onEmployeeSelectionChange: (selector: EmployeeSelectorV2MultiSelectState) => void
}

export enum TimeoffExportType {
  companyTimeoff = 'company_timeoff',
  activityTimeoff = 'activity_timeoff',
  scheduleTimeoff = 'schedule_timeoff',
  usedTimeoff = 'used_timeoff',
}

const TimeoffTypeSelect = ({ form, onEmployeeSelectionChange }: Props) => {
  const timeoffTypeOptions = [
    {
      label: i18n.t('employees.reports.timeoff_options.company_timeoff'),
      value: TimeoffExportType.companyTimeoff,
    },
    {
      label: i18n.t('employees.reports.timeoff_options.used_timeoff'),
      value: TimeoffExportType.usedTimeoff,
    },
    {
      label: i18n.t('employees.reports.timeoff_options.activity_timeoff'),
      value: TimeoffExportType.activityTimeoff,
    },
    {
      label: i18n.t('employees.reports.timeoff_options.schedule_timeoff'),
      value: TimeoffExportType.scheduleTimeoff,
    },
  ]

  return (
    <>
      <FormRow>
        <Box className="sidebar_employees_export_employee_data_timeoff_timeoff_type_button">
          <Select
            label={i18n.t('employees.reports.timeoff_type')}
            field={form.get('kind')}
            options={timeoffTypeOptions}
          />
        </Box>
      </FormRow>

      {form.get('kind').value === TimeoffExportType.companyTimeoff && (
        <CompanyTimeoffFields form={form} onEmployeeSelectionChange={onEmployeeSelectionChange} />
      )}
      {form.get('kind').value === TimeoffExportType.activityTimeoff && (
        <ActivityTimeoffFields form={form} onEmployeeSelectionChange={onEmployeeSelectionChange} />
      )}
      {form.get('kind').value === TimeoffExportType.usedTimeoff && (
        <UsedTimeoffFields form={form} onEmployeeSelectionChange={onEmployeeSelectionChange} />
      )}
      {form.get('kind').value === TimeoffExportType.scheduleTimeoff && (
        <ScheduleTimeoffFields form={form} onEmployeeSelectionChange={onEmployeeSelectionChange} />
      )}
    </>
  )
}

export default observer(TimeoffTypeSelect)
